
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwsome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';
const WHOLE_YEAR = momentHelper.getMonth()
class ReportAnalysisClaimOfTheMonth extends Component {
  constructor(props) {
    super(props)
    const optionsRows = [10,20,50,100,0];
    this.state = {
      loading:false,
      activePage:1,
      defaultRows:20,
      totalPage:1,
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      optionsRows:optionsRows,
      data:[],
      isRange: false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      showDetail:false,
      isSubMenu:false,
      subMenu:[],
      type:'',
      payment_type:'',
      dataExcel:[]
    }
    this.refTableId = 'ReportAnalysisClaimOfTheMonth-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadInsureStat(this.state.year,this.state.month,this.state.day)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getNumberFormat(value,decimal=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadExcelData(complete=undefined) {
    let {year,month} = this.state
    ReportStore.loadAnalysisClaimOfTheMonth(year,month,'','',(result)=>{
      this.setState({dataExcel:result.data,loading:false})
      complete('OK')
    })
  }

  loadInsureStat(year='',month='',day='') {
    let {activePage,defaultRows} = this.state
    let start = (activePage*defaultRows)-defaultRows
    if (activePage===1)
      start = 0
    ReportStore.loadAnalysisClaimOfTheMonth(year,month,start,(defaultRows===0?'':defaultRows),(result)=>{
      let totalPage = result.data_count/defaultRows
      if (defaultRows===0)
        totalPage = 1
      this.setState({loading:false,data:result.data,totalPage:(Math.ceil(totalPage)===0?1:Math.ceil(totalPage))})
    })
  }

  loadInsureStatRange(start='',end='') {
    ReportStore.loadInsureStatRange('insurer',start,end,'',(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadInsureStat(this.state.year,this.state.month,val.value)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(this.state.year,val.value,_day)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(val.value,this.state.month,_day)
  }

  onPageSelect(eventKey) {
    let date = this.state.year-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      activePage:eventKey,day:_day
    },()=>{
      this.loadInsureStat(this.state.year,this.state.month,_day)
    })
  }

  onRowsPerPageChange(e) {
    let date = this.state.year-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      defaultRows:e,activePage:1,day:_day
    },()=>{
      this.loadInsureStat(this.state.year,this.state.month,_day)
    })
  }

  onExportExcel(e) {
    this.loadExcelData((result)=>{
      if (result==='OK') {
        const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
        let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }    
        const fileName = 'รายงานรถแจ้งเคลมประจำเดือน.xlsx'
        FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
        this.setState({showExport:false})
      }
    })    
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportSummary&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false&viewForm='
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportSummary&start_date='+start+'&end_date='+end+'&isRange=true&viewForm='
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadInsureStat(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadInsureStatRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadInsureStatRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={false}
            year={this.state.year}
            month={this.state.month}
            // day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            // onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={false}
            // renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        {' '}
        <FormGroup style={{verticalAlign:'top'}}>
          <PrintButtons
            // onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadInsureStat(this.state.year,this.state.month,this.state.day)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwsome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  renderRowData() {
    let {data,activePage,defaultRows} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          let number = 1
          if (activePage===1)
            number = index+1
          else {
            number = (activePage*defaultRows)-defaultRows
            number += (index+1)
          }  
          return(
            <tr key={index}>
              <td className='text-center'>{number}</td>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{item.fixing_day}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.car_regisatrion_no}</td>
              <td className='text-left'>{item.remark}</td>
            </tr>
          )
        })
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    // if (isRange) {
    //   let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
    //   let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
    //   return 'ประจำวันที่ '+start+' - '+end
    // } else {
    //   let text = 'ประจำวันที่ '
    //   text += day+' '+momentHelper.getMonthText(month)+' '+year
    //   if (year==='0'||year==='00'||year===0) {
    //     text = 'ทั้งหมด'
    //   } else if (month==='0'||month==='00'||month===0) {
    //     text = 'ประจำปี '+year
    //   } else if (day==='0'||day==='00'||day===0) {
    //     text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
    //   }
    //   return text
    // }
    let text = momentHelper.getMonthText(month)+' '+year  
    return text
  }

  renderTable() {
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th className='text-center' colSpan={7}>รายงานรถแจ้งเคลมประจำเดือน {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px'}}>วันที่</th>
              <th className='text-center' style={{width:'80px'}}>รวมรายวัน</th>
              <th className='text-center' style={{width:'100px'}}>ประกันภัย</th>
              <th className='text-center' style={{width:'90px'}}>รุ่นรถ</th>
              <th className='text-center' style={{width:'110px'}}>ทะเบียน</th>
              <th className='text-center' style={{width:'150px'}}>หมายเหตุ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderExcelRowData() {
    let {dataExcel} = this.state
    if (dataExcel.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        dataExcel.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{item.fixing_day}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.car_regisatrion_no}</td>
              <td className='text-left'>{item.remark}</td>
            </tr>
          )
        })
      )
    }
  }

  renderExcelTable() {
    return (
      <div className='table-responsive'>
        <table id={this.refTableId} className='table table-hover table-bordered-solid' style={{display:'none'}}>
          <thead>
            <tr>
              <th className='text-center' colSpan={7}>รายงานรถแจ้งเคลมประจำเดือน {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px'}}>วันที่</th>
              <th className='text-center' style={{width:'80px'}}>รวมรายวัน</th>
              <th className='text-center' style={{width:'100px'}}>ประกันภัย</th>
              <th className='text-center' style={{width:'90px'}}>รุ่นรถ</th>
              <th className='text-center' style={{width:'110px'}}>ทะเบียน</th>
              <th className='text-center' style={{width:'150px'}}>หมายเหตุ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderExcelRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderPaging() {
    return (
                <div className="text-right">
                  <Form inline>
                    <FormGroup>
                      จำนวนแถวต่อหน้า
                    </FormGroup>  
                    {' '}
                    <FormGroup>
                      <DropdownButton id='dd-report-analysis-claim-of-the-month' bsStyle={'default'} title={this.state.defaultRows===0?'ทั้งหมด':this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
                        {this.state.optionsRows.map((item,index)=>(
                          <MenuItem key={index} eventKey={item}>{item===0?'ทั้งหมด':item}</MenuItem>  
                        ))}
                      </DropdownButton>
                    </FormGroup> 
                    {' '}
                    <FormGroup style={{lineHeight:'10px'}}>
                      <Pagination
                        prev='ก่อนหน้า'
                        next='ถัดไป'
                        first={false}
                        last={false}
                        ellipsis
                        boundaryLinks
                        items={this.state.totalPage}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.onPageSelect.bind(this)}
                      />
                    </FormGroup>  
                  </Form>  
                </div>
    )
  }

  render() {
    const reportName = 'รายงานสรุปยอดรายได้ประกัน (รายเดือน)'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {this.renderExcelTable()}
          {this.renderPaging()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportAnalysisClaimOfTheMonth.defaultProps = {
  show:false
}
export default ReportAnalysisClaimOfTheMonth;





// WEBPACK FOOTER //
// ./src/view/report/analysis/ReportAnalysisClaimOfTheMonth.js